export const createVideosModule = () => {
  return {
    state: {},
    getters: {
      allVideos: () => (
        [
          "230571947",
          "395895502",
          "212574130",
          "230593602",
          "236044783",
          "234815511",
          "435672509",
        ]
      ),
      video_clinicalApplication1: () => "230571947",
      video_clinicalApplication3: () => "395895502",
      video_clinicalApplication5: () => "212574130",
      video_clinicalApplication7: () => "230593602",
      video_clinicalApplication10: () => "435672509",
      video_priniciples1: () => "236044783",
      video_priniciples2: () => "234815511"
    }
  }
}
